// // import { useRef } from 'react';
// // import React from 'react'
// // import '../../../Style/online-train/form.css'
// // import { useState } from 'react'
// // // import Downloads from '../Download/NewDown';
// // // import Answer from '../Download/Answer';
// // import DownloadAddWork from '../Download/DownloadAddWork'
// // const random = (min, max) => {
// //   return (Math.floor(Math.random() * (max - min + 1)) + min);
// // }
// // const Level1Add = () => {

// //   const getswitch = (digit1) => {
// //     switch (digit1) {
// //       case '1':
// //         return random(1, 9)
// //         break;
// //       case '2':
// //         return random(10, 99)
// //         break;
// //       case '3':
// //         return random(100, 999)
// //         break;
// //       case '4':
// //         return random(1000, 9999)
// //         break;
// //       default:
// //         break;
// //     }
// //   }
// //   const [digit1, setdigit1] = React.useState();
// //   const [row, setrow] = React.useState();
// //   const [ques, setques] = React.useState();
// //   const [file, setfile] = React.useState();
// //   const [sub, setsub] = React.useState(0);
// //   const [zig, setzig] = React.useState(0);
// //   const [isans, setisans] = React.useState(1);
// //   const [btn, setbtn] = React.useState(0);
// //   const [lessthan, setlessthan] = React.useState(0);
// //   // const mat = []
// //   const [mat, setmat] = useState([])
// //   const [refrsh, setrefrsh] = useState(0)
// //   const [showPopup, setShowPopup] = useState(false);
// //   let lowval = 1;

// //   const refpdf = useRef();

// //   const getmat = (ques, row) => {

// //   }
// //   const handleSubmit = (e) => {
// //     e.preventDefault();
// //     setShowPopup(true);
// //   };



// //   function Xbtn(event) {
// //     setbtn(0)
// //     // window.location.reload()    
// //   }

// //   function cal(event) {
// //     event.preventDefault();
// //     if (refrsh) {
// //       window.location.reload()
// //     }
// //     // if (!sub && !zig) {
// //     //   getmat(ques, row)
// //     // }

// //     let min;
// //     let max;

// //     switch (digit1) {
// //       case '1':
// //         min = 1
// //         max = 9
// //         break;
// //       case '2':
// //         min = 10
// //         max = 99
// //         break;
// //       case '3':
// //         min = 100
// //         max = 999
// //         break;
// //       case '4':
// //         min = 1000
// //         max = 9999
// //         break;
// //       default:
// //         break;
// //     }

// //     if (!zig && !sub && !lessthan) {
// //       let temp = []
// //       let ele;
// //       for (let j = 0; j < ques; j++) {
// //         for (let i = 0; i < row; i++) {
// //           ele = getswitch(digit1)
// //           temp.push(ele)
// //         }
// //         mat.push(temp)
// //         temp = []
// //       }
// //     }

// //     if ((!zig && !sub && lessthan) || (zig && !sub && lessthan)) {
// //       if (row > 4 || digit1 > 2) {
// //         alert("soory! In level-2 the row shloud be lessthan 4 and digit must be lessthan or equal  2")
// //       } else {
// //         if (zig && lessthan && !sub) {
// //           min = 1;
// //         }
// //         for (let i = 0; i < ques; i++) {
// //           let temp = [];
// //           let tem1 = 0;
// //           let tem2 = 0;
// //           let tem3 = 0;
// //           let tem4 = 0;
// //           do {

// //             if (row == 2) {
// //               tem1 = random(min, max)
// //               tem2 = random(min, max)
// //             } else if (row == 3) {
// //               tem1 = random(min, max)
// //               tem2 = random(min, max)
// //               tem3 = random(min, max)
// //             } else if (row == 4) {
// //               tem1 = random(min, max)
// //               tem2 = random(min, max)
// //               tem3 = random(min, max)
// //               tem4 = random(min, max)
// //             }

// //           } while ((tem1 + tem2 + tem3 + tem4) >= 100)

// //           if (row == 2) {
// //             temp.push(tem1)
// //             temp.push(tem2)
// //             // temp.push(tem3)
// //           } else if (row == 3) {
// //             temp.push(tem1)
// //             temp.push(tem2)
// //             temp.push(tem3)
// //           } else if (row == 4) {
// //             temp.push(tem1)
// //             temp.push(tem2)
// //             temp.push(tem3)
// //             temp.push(tem4)
// //           }

// //           mat.push(temp)
// //         }

// //       }
// //     }

// //     if (zig && !sub && !lessthan) {
// //       console.log("ss3")

// //       let temp = []
// //       let ele;
// //       for (let j = 0; j < ques; j++) {
// //         for (let i = 0; i < row; i++) {
// //           ele = random(1, max)
// //           if (random(1, 9) == 2 || random(1, 9) == 6) {
// //             ele = random(1, 50)
// //           }
// //           temp.push(ele)
// //         }
// //         mat.push(temp)
// //         temp = []
// //       }
// //     }




// //     if (!zig && sub && !lessthan) {
// //       for (let i = 0; i < ques; i++) {
// //         let temo = [];
// //         let total = 0;
// //         for (let j = 0; j < row; j++) {
// //           let ele = 0;
// //           do {
// //             if (total == 0) {
// //               ele = random(min, max)
// //             } else {
// //               // console.log(total)
// //               // ele = random(-max, max);
// //               if (random(2, 3) == 3) {
// //                 ele = random(-min, -max)
// //               } else {
// //                 ele = random(min, max)
// //               }
// //               if (Math.sign(ele + total) == -1) {
// //                 while (Math.sign(ele + total) <= -1) {
// //                   ele = random(min, max)
// //                 }
// //               }
// //             }
// //           } while ((temo.includes(Math.abs(ele)) && Math.sign(ele) == -1) || ele == 0)
// //           total = ele + total
// //           temo.push(ele)
// //         }
// //         mat.push(temo)
// //         temo = []
// //       }
// //     }


// //     if (!zig && sub && !lessthan) {

// //       for (let i = 0; i < ques; i++) {
// //         let temp = [];
// //         let rowSum = 0;
// //         let cumulativeSum = 0; // Tracks cumulative sum to ensure it doesn't go negative

// //         for (let j = 0; j < row; j++) {
// //           let ele;

// //           do {
// //             // Generate random value between -max and max
// //             ele = Math.floor(Math.random() * (2 * max + 1)) - max;
// //           } while (
// //             rowSum + ele > 100 ||                // Ensure total row sum does not exceed 100
// //             rowSum + ele < 0 ||                  // Ensure total row sum is not negative
// //             cumulativeSum + ele < 0              // Ensure cumulative sum is non-negative at each step
// //           );

// //           temp.push(ele);
// //           rowSum += ele;
// //           cumulativeSum += ele;
// //         }

// //         mat.push(temp);
// //       }

// //     }



// //     if (sub && zig && !lessthan) {
// //       for (let i = 0; i < ques; i++) {
// //         let temo = [];
// //         let total = 0;
// //         for (let j = 0; j < row; j++) {
// //           let ele = 0;
// //           if (total == 0) {
// //             ele = random(min, max)
// //           } else {
// //             ele = random(-total, total);
// //           }
// //           total = ele + total
// //           temo.push(ele)
// //         }
// //         mat.push(temo)
// //         temo = []
// //       }

// //     }



// //     if ((!zig && sub && lessthan) || (zig && sub && lessthan)) {
// //       // if(zig && sub && lessthan){
// //       //   threshold = 0
// //       // }
// //       for (let i = 0; i < ques; i++) {
// //         let temp = [];
// //         let sum = 0;
// //         let cumulativeSum = 0;

// //         for (let j = 0; j < row; j++) {
// //           let num;
// //           do {
// //             num = random(-max, max); // Can be negative or positive
// //           } while (sum + num >= 100 || (cumulativeSum + num < 0) || num == 0);

// //           temp.push(num);
// //           sum += num;
// //           cumulativeSum += num;
// //         }

// //         mat.push(temp);
// //       }
// //     }

// //     if (mat.length != 0) {
// //       setbtn(1)
// //     }

// //   }

// //   let props = {
// //     ques: ques,
// //     row: row,
// //     mat: mat,
// //     file: file,
// //     isans: isans

// //   }


// //   const targetRef = useRef();

// //   return (
// //     <div className='bg'>
// //       <div className='main'>
// //         <form onSubmit={cal} className='main-form'>
// //           <div className='form-back-img'></div>
// //           <h2 className='form-name'>Add<span className='underline'>ition/Subract</span>ion (Level 1)</h2>
// //           <label htmlFor="digit">Number of Digit</label>
// //           <input type="number" max="4" className='box' name="name" id="digit" placeholder="2" onChange={(e) => { setdigit1(e.target.value) }} required />

// //           <label htmlFor="row">Number of Rows</label>
// //           <input type="number" name="email" className='box' id="row" placeholder="3" required onChange={(e) => { setrow(e.target.value) }} />
// //           <div className='check' >
// //             <label htmlFor="sub">Include Subraction  </label>
// //             <div class="checkbox-wrapper-2">
// //               <input type="checkbox" name="reference" className="sc-gJwTLC ikxBAC" id="sub" onClick={() => { return sub ? setsub(false) : setsub(true) }} />
// //             </div>
// //           </div>
// //           <div className='check'>
// //             <label htmlFor="zig">Zig-zag  </label>
// //             {/* <span className='arrow'>&#8594;</span> */}
// //             <div class="checkbox-wrapper-2">
// //               {/* <input type="checkbox" class="sc-gJwTLC ikxBAC" /> */}
// //               <input type="checkbox" className="sc-gJwTLC ikxBAC" name="zig-zag" id="zig-zag" onClick={() => { return zig ? setzig(false) : setzig(true) }} />

// //             </div>
// //           </div>
// //           <div className='check'>
// //             <label htmlFor="lessthan100">Level 2  </label>
// //             <div class="checkbox-wrapper-2">
// //               <input type="checkbox" className="sc-gJwTLC ikxBAC" name="lessthan" id="lessthan" onClick={() => { return lessthan ? setlessthan(false) : setlessthan(true) }} />
// //             </div>
// //           </div>
// //           <label htmlFor='ques'>No Of Questions</label>
// //           <input type="number" name="ques" id="ques" className="box" placeholder="10" required onChange={(e) => { setques(e.target.value) }} />
// //           <label htmlFor='ques'>File name</label>
// //           <input type="text" name="file" id="file" className="box" placeholder="file name.." required onChange={(e) => { setfile(e.target.value) }} />

// //           <div className='submit'>
// //             <input type="submit" className='bt-purple' id='reset' value="Finish" />
// //             <input type="reset" className='bt-purple' id='reset' value="Refresh" onClick={() => { window.location.reload() }} />
// //           </div>
// //         </form>
// //       </div>
// //       {/* <div className={btn ? "pop-bg" : "no-pop-bg"}></div> */}
// //       {/* <div className={btn ? "pop-up" : "no-pop-up"} >
// //         <button className='X-btn' onClick={() => { setbtn(0) }}>X</button>
// //         <div className='pop-up-bg'>
// //           <DownloadAddWork {...{ row, mat, ques, file }} />
// //           <DownloadAddWork {...{ row, mat, ques, file, isans }} />
// //         </div>
// //       </div> */}

// //       <div className={btn ? "popUp-download" : "hide-popUp-download"}>
// //         <button className='X-btn' onClick={() => { Xbtn() }}>X</button>
// //         <div className='download-ques-btn'>
// //           <DownloadAddWork {...{ row, mat, ques, file }} />
// //           <DownloadAddWork {...{ row, mat, ques, file, isans }} />
// //         </div>
// //       </div>

// //     </div>
// //   )
// // }
// // export default Level1Add


// import { useRef } from 'react';
// import React from 'react'
// import '../../../Style/online-train/form.css'
// import { useState } from 'react'
// import DownloadAddWork from '../Download/DownloadAddWork'

// const random = (min, max) => {
//   return (Math.floor(Math.random() * (max - min + 1)) + min);
// }

// // ---------------------------------------------------------------
// // Digit-chain algorithm
// // ---------------------------------------------------------------
// const data_dict = {
//   0: [0],
//   1: [2, 3, 5, -1],
//   2: [2, 5, -2, -1],
//   3: [1, 5, -1, -2, -3],
//   4: [5, -1, -2, -3, -4],
//   5: [4, -5],
//   6: [3, 2, 1, -1, -5, -6],
//   7: [2, 1, -2, -5, -1, -6, -7],
//   8: [0, 1, -3, -5, -2, -1, -6, -7, -8],
//   9: [0, -1, -2, -3, -4, -5, -6, -7, -8, -9]
// };

// // splits a number into its place-digits, most significant first
// // e.g. splitDigits(49, 2) -> [4, 9]
// const splitDigits = (num, numDigits) => {
//   const str = Math.abs(num).toString().padStart(numDigits, '0');
//   return str.split('').map(Number);
// };

// // picks one value from data_dict[d] for each digit in `digits`.
// // if a digit is 0, instead of using data_dict[0], pick a random digit 0-9
// // and a random sign for that slot.
// // re-rolls until every pick shares the same sign.
// const pickNextDigits = (digits) => {
//   let picks;
//   let sign;
//   let attempts = 0;

//   do {
//     picks = digits.map((d) => {
//       if (d === 0) {
//         const randDigit = random(0, 9);
//         const randSign = random(0, 1) === 0 ? 1 : -1;
//         return randDigit === 0 ? 0 : randDigit * randSign;
//       }
//       const options = data_dict[d];
//       return options[random(0, options.length - 1)];
//     });

//     const signs = picks.map((p) => Math.sign(p)); // -1, 0, or 1
//     const nonZeroSigns = signs.filter((s) => s !== 0);
//     sign = nonZeroSigns.length === 0 ? 1 : nonZeroSigns[0];

//     attempts++;
//     if (attempts > 200) {
//       // safety valve so it can't infinite-loop on a bad digit combo
//       sign = 1;
//       picks = digits.map((d) => (d === 0 ? 0 : Math.abs(data_dict[d][0])));
//       break;
//     }
//   } while (!picks.every((p) => Math.sign(p) === sign || p === 0));

//   const digitsAbs = picks.map((p) => Math.abs(p));
//   const value = Number(digitsAbs.map(String).join(''));
//   return sign === -1 ? -value : value;
// };

// // generates one full row (chain) of `row` numbers, each with `numDigits` digits.
// // each next number is generated from the digits of the RUNNING SUM so far,
// // not from the previous generated number itself.
// const genChainRowOnce = (numDigits, row) => {
//   const temp = [];
//   let runningSum = 0;

//   // first number: plain random, always positive
//   const min = numDigits === 1 ? 1 : Math.pow(10, numDigits - 1);
//   const max = Math.pow(10, numDigits) - 1;
//   const first = random(min, max);

//   temp.push(first);
//   runningSum = first;

//   for (let i = 1; i < row; i++) {
//     let next;
//     let attempts = 0;
//     const sumDigits = splitDigits(runningSum, numDigits);
//     const usedMagnitudes = temp.map((v) => Math.abs(v));

//     do {
//       next = pickNextDigits(sumDigits);
//       attempts++;
//       if (attempts > 300) break; // avoid infinite loop if constraints unsatisfiable
//     } while (
//       runningSum + next <= 0 ||              // running total must never hit zero or go negative
//       Math.abs(next) === runningSum ||       // reject trivial "mirrors the running sum" picks
//       usedMagnitudes.includes(Math.abs(next)) // reject repeating a magnitude already used in this row
//     );

//     temp.push(next);
//     runningSum += next;
//   }

//   return { temp, finalTotal: runningSum };
// };

// // MIN_FINAL_TOTAL: final answers landing below this get retried, since the
// // digit-chain naturally drifts toward small totals (every step only moves by
// // a single-digit amount and can never go negative/zero, so it "settles" low).
// // This doesn't ban small totals outright, just cuts how often they show up.
// const MIN_FINAL_TOTAL = 10;
// const MAX_ROW_RETRIES = 25;

// const genChainRow = (numDigits, row) => {
//   let best = null;

//   for (let attempt = 0; attempt < MAX_ROW_RETRIES; attempt++) {
//     const result = genChainRowOnce(numDigits, row);
//     if (result.finalTotal >= MIN_FINAL_TOTAL) {
//       return result.temp;
//     }
//     best = result.temp; // keep the last attempt as a fallback
//   }

//   // if every retry still landed small, accept the last one rather than loop forever
//   return best;
// };

// // generates `ques` rows, following the same digit1/row naming as Level1Add
// const genChainMatrix = (digit1, row, ques) => {
//   const numDigits = Number(digit1);
//   const result = [];
//   for (let q = 0; q < ques; q++) {
//     result.push(genChainRow(numDigits, row));
//   }
//   return result;
// };
// // ---------------------------------------------------------------

// const FIXED_DIGITS = '2'; // number of digits used for the digit-chain algorithm (field removed from form)

// const Level1Add = () => {

//   const [row, setrow] = React.useState();
//   const [ques, setques] = React.useState();
//   const [file, setfile] = React.useState();
//   const [isans, setisans] = React.useState(1);
//   const [btn, setbtn] = React.useState(0);
//   const [mat, setmat] = useState([])
//   const [refrsh, setrefrsh] = useState(0)
//   const [showPopup, setShowPopup] = useState(false);
//   let lowval = 1;

//   const refpdf = useRef();

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setShowPopup(true);
//   };

//   function Xbtn(event) {
//     setbtn(0)
//   }

//   function cal(event) {
//     event.preventDefault();
//     if (refrsh) {
//       window.location.reload()
//     }

//     const newMat = genChainMatrix(FIXED_DIGITS, row, ques);
//     newMat.forEach((r) => mat.push(r));

//     if (mat.length != 0) {
//       setbtn(1)
//     }

//   }

//   let props = {
//     ques: ques,
//     row: row,
//     mat: mat,
//     file: file,
//     isans: isans
//   }

//   const targetRef = useRef();

//   return (
//     <div className='bg'>
//       <div className='main'>
//         <form onSubmit={cal} className='main-form'>
//           <div className='form-back-img'></div>
//           <h2 className='form-name'>Add<span className='underline'>ition/Subract</span>ion (Level 1)</h2>

//           <label htmlFor="row">Number of Rows</label>
//           <input type="number" name="email" className='box' id="row" placeholder="3" required onChange={(e) => { setrow(e.target.value) }} />

//           <label htmlFor='ques'>No Of Questions</label>
//           <input type="number" name="ques" id="ques" className="box" placeholder="10" required onChange={(e) => { setques(e.target.value) }} />
//           <label htmlFor='ques'>File name</label>
//           <input type="text" name="file" id="file" className="box" placeholder="file name.." required onChange={(e) => { setfile(e.target.value) }} />

//           <div className='submit'>
//             <input type="submit" className='bt-purple' id='reset' value="Finish" />
//             <input type="reset" className='bt-purple' id='reset' value="Refresh" onClick={() => { window.location.reload() }} />
//           </div>
//         </form>
//       </div>

//       <div className={btn ? "popUp-download" : "hide-popUp-download"}>
//         <button className='X-btn' onClick={() => { Xbtn() }}>X</button>
//         <div className='download-ques-btn'>
//           <DownloadAddWork {...{ row, mat, ques, file }} />
//           <DownloadAddWork {...{ row, mat, ques, file, isans }} />
//         </div>
//       </div>

//     </div>
//   )
// }
// export default Level1Add


import { useRef } from 'react';
import React from 'react'
import '../../../Style/online-train/form.css'
import { useState } from 'react'
import DownloadAddWork from '../Download/DownloadAddWork'

const random = (min, max) => {
  return (Math.floor(Math.random() * (max - min + 1)) + min);
}

// ---------------------------------------------------------------
// Digit-chain algorithm
// ---------------------------------------------------------------
const data_dict = {
  0: [0],
  1: [2, 3, 5, -1],
  2: [2, 5, -2, -1],
  3: [1, 5, -1, -2, -3],
  4: [5, -1, -2, -3, -4],
  5: [4, -5],
  6: [3, 2, 1, -1, -5, -6],
  7: [2, 1, -2, -5, -1, -6, -7],
  8: [0, 1, -3, -5, -2, -1, -6, -7, -8],
  9: [0, -1, -2, -3, -4, -5, -6, -7, -8, -9]
};

// splits a number into its place-digits, most significant first
// e.g. splitDigits(49, 2) -> [4, 9]
const splitDigits = (num, numDigits) => {
  const str = Math.abs(num).toString().padStart(numDigits, '0');
  return str.split('').map(Number);
};

// returns the digit choices available for place-digit `d` under a given sign.
// zero place: positive -> any digit 0-9 is allowed,
//             negative -> only 0 is allowed (can't subtract from an empty column).
// non-zero place: entries of data_dict[d] matching that sign (0 is always allowed).
const optionsForDigit = (d, sign) => {
  if (d === 0) {
    return sign === -1 ? [0] : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  }
  return data_dict[d]
    .filter((v) => v === 0 || Math.sign(v) === sign)
    .map((v) => Math.abs(v));
};

// picks a whole number to place next, given the digits of the current running sum.
// sign is decided FIRST, then each place is filled from the options valid for
// that sign, so the zero-place rule above can be applied consistently.
// the leading place is never allowed to be 0, so the result always has exactly
// as many digits as the running sum (no 5 sneaking out of a 2-digit sheet).
const pickNextDigits = (digits) => {
  let attempts = 0;

  while (attempts < 200) {
    attempts++;

    const sign = random(0, 1) === 0 ? 1 : -1;
    const perPlace = digits.map((d, idx) => {
      const opts = optionsForDigit(d, sign);
      // leading place must stay non-zero to preserve the digit width
      return idx === 0 && digits.length > 1 ? opts.filter((v) => v !== 0) : opts;
    });

    // if any place has no valid option under this sign, try again with a new sign
    if (perPlace.some((opts) => opts.length === 0)) continue;

    const chosen = perPlace.map((opts) => opts[random(0, opts.length - 1)]);
    const value = Number(chosen.map(String).join(''));

    if (value === 0) continue; // never emit a plain zero

    return sign === -1 ? -value : value;
  }

  return null; // no valid pick under either sign
};

// generates one full row (chain) of `row` numbers, each with `numDigits` digits.
// each next number is generated from the digits of the RUNNING SUM so far,
// not from the previous generated number itself.
const genChainRowOnce = (numDigits, row) => {
  const temp = [];
  let runningSum = 0;

  // first number: plain random, always positive
  const min = numDigits === 1 ? 1 : Math.pow(10, numDigits - 1);
  const max = Math.pow(10, numDigits) - 1;
  const maxForDigits = max; // running sum must never exceed this
  const first = random(min, max);

  temp.push(first);
  runningSum = first;

  for (let i = 1; i < row; i++) {
    let next = null;
    let ok = false;

    const sumDigits = splitDigits(runningSum, numDigits);

    for (let attempts = 0; attempts < 300; attempts++) {
      const candidate = pickNextDigits(sumDigits);
      if (candidate === null) continue;

      // running total must never hit zero or go negative
      if (runningSum + candidate <= 0) continue;
      // running total must stay within the chosen digit width, so a 2-digit
      // sheet never grows a 3-digit sum (which would breed 3-digit numbers)
      if (runningSum + candidate > maxForDigits) continue;
      // reject trivial "cancels the whole running sum" picks
      if (Math.abs(candidate) === runningSum) continue;
      // reject undoing an earlier number: same magnitude, opposite sign
      // (e.g. 22 earlier then -22 now)
      if (temp.some((v) => Math.abs(v) === Math.abs(candidate) && Math.sign(v) !== Math.sign(candidate))) continue;

      next = candidate;
      ok = true;
      break;
    }

    // constraints unsatisfiable from here - abandon this row, caller retries
    if (!ok) return { temp, finalTotal: runningSum, valid: false };

    temp.push(next);
    runningSum += next;
  }

  return { temp, finalTotal: runningSum, valid: true };
};

// final answers landing below this get retried, since the digit-chain naturally
// drifts toward small totals (each step only moves by a single-digit amount and
// can never go negative/zero, so it "settles" low). Scales with digit count so
// 1-digit sheets aren't held to a 2-digit threshold. Doesn't ban small totals
// outright, just cuts how often they show up.
const minFinalTotal = (numDigits) => (numDigits <= 1 ? 3 : Math.pow(10, numDigits - 1));
const MAX_ROW_RETRIES = 25;

const genChainRow = (numDigits, row) => {
  let best = null;
  const threshold = minFinalTotal(numDigits);

  for (let attempt = 0; attempt < MAX_ROW_RETRIES; attempt++) {
    const result = genChainRowOnce(numDigits, row);
    if (!result.valid) continue; // row got stuck - throw it away and start over

    if (result.finalTotal >= threshold) {
      return result.temp;
    }
    best = result.temp; // valid, just a small total - keep as fallback
  }

  // every retry landed small (or got stuck); use the best valid row we saw,
  // and only as a last resort build a trivially valid one
  if (best) return best;
  return genChainRowOnce(numDigits, row).temp;
};

// generates `ques` rows, following the same digit1/row naming as Level1Add
const genChainMatrix = (digit1, row, ques) => {
  const numDigits = Number(digit1);
  const result = [];
  for (let q = 0; q < ques; q++) {
    result.push(genChainRow(numDigits, row));
  }
  return result;
};
// ---------------------------------------------------------------

const Combination  = () => {

  const [digit1, setdigit1] = React.useState();
  const [row, setrow] = React.useState();
  const [ques, setques] = React.useState();
  const [file, setfile] = React.useState();
  const [isans, setisans] = React.useState(1);
  const [btn, setbtn] = React.useState(0);
  const [mat, setmat] = useState([])
  const [refrsh, setrefrsh] = useState(0)
  const [showPopup, setShowPopup] = useState(false);
  let lowval = 1;

  const refpdf = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowPopup(true);
  };

  function Xbtn(event) {
    setbtn(0)
  }

  function cal(event) {
    event.preventDefault();
    if (refrsh) {
      window.location.reload()
    }

    const newMat = genChainMatrix(digit1, row, ques);
    newMat.forEach((r) => mat.push(r));

    if (mat.length != 0) {
      setbtn(1)
    }

  }

  let props = {
    ques: ques,
    row: row,
    mat: mat,
    file: file,
    isans: isans
  }

  const targetRef = useRef();

  return (
    <div className='bg'>
      <div className='main'>
        <form onSubmit={cal} className='main-form'>
          <div className='form-back-img'></div>
          <h2 className='form-name'>Add<span className='underline'>ition/Subract</span>ion (No Combination)</h2>

          <label htmlFor="digit">Number of Digit</label>
          <input type="number" min="1" max="4" className='box' name="digit" id="digit" placeholder="2" required onChange={(e) => { setdigit1(e.target.value) }} />

          <label htmlFor="row">Number of Rows</label>
          <input type="number" name="email" className='box' id="row" placeholder="3" required onChange={(e) => { setrow(e.target.value) }} />

          <label htmlFor='ques'>No Of Questions</label>
          <input type="number" name="ques" id="ques" className="box" placeholder="10" required onChange={(e) => { setques(e.target.value) }} />
          <label htmlFor='ques'>File name</label>
          <input type="text" name="file" id="file" className="box" placeholder="file name.." required onChange={(e) => { setfile(e.target.value) }} />

          <div className='submit'>
            <input type="submit" className='bt-purple' id='reset' value="Finish" />
            <input type="reset" className='bt-purple' id='reset' value="Refresh" onClick={() => { window.location.reload() }} />
          </div>
        </form>
      </div>

      <div className={btn ? "popUp-download" : "hide-popUp-download"}>
        <button className='X-btn' onClick={() => { Xbtn() }}>X</button>
        <div className='download-ques-btn'>
          <DownloadAddWork {...{ row, mat, ques, file }} />
          <DownloadAddWork {...{ row, mat, ques, file, isans }} />
        </div>
      </div>

    </div>
  )
}
export default Combination 